export default "__VITE_ASSET__BYt8A67___"